import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Redirect } from 'react-router-dom';

import OktaWidget from '../../components/OktaWidget';

import { useSelector } from 'react-redux';

import { ReduxStates } from '../../redux/reduxTypes';

// import { oktaSignInConfig } from '../../config';
import { getOktaSignInConfig } from '../../config';
import { fetchCall } from '../../services/api';

interface LoginResponse {
  hostname: string;
  clientid: string;
}

const Login = (): React.ReactElement | null => {
  const { oktaAuth, authState } = useOktaAuth();
  const [clientId, setClientID] = useState<string | null>(null);
  const config = useSelector((state: ReduxStates) => state.config);
  const user = useSelector((state: ReduxStates) => state.user);
  const [oktaSignInConfig, setOktaSignInConfig] = useState<any>(null);
  const [userModules, setUserModules] = useState<Array<string> | null>(null);
  const [login, setUserLogin] = useState<boolean | undefined>(false);

  // set document title
  document.title = 'Login - Acential Connect';

  const fetchClientId = async () => {
    try {
      const response: LoginResponse = await fetchCall(`${config.react_app_api_base_url}/multitenancy/id`, {
        ['hostName']:
          window.location.host === 'localhost:3000' ? 'master.d2fmxqvi3se2z0.amplifyapp.com' : window.location.host
      });
      setClientID(response.clientid);
    } catch (error) {
      // TODO: error UI?
      console.log(error);
    }
  };

  const onSuccess = async (tokens: any) => {
    try {
      oktaAuth.handleLoginRedirect(tokens);
    } catch (error) {
      console.log(error);
    }
  };

  const onError = (err: Error) => {
    console.log('error logging in', err);
  };

  useEffect(() => {
    fetchClientId();
    const oktaConfig = getOktaSignInConfig(config.react_app_okta_url);
    setOktaSignInConfig(oktaConfig);
  }, []);

  useEffect(() => {
    if (user) {
      setUserModules(user.userModules);
      setUserLogin(user.login);
    }
  }, [user]);

  if (authState?.isPending) return null;

  if (!clientId || !oktaSignInConfig) return null;

  return authState?.isAuthenticated ? (
    userModules && !userModules?.length && login ? (
      <Redirect to="/no-access" />
    ) : login ? (
      <Redirect to="/glance" />
    ) : null
  ) : (
    <OktaWidget config={{ ...oktaSignInConfig, clientId }} onSuccess={onSuccess} onError={onError} />
  );
};

export default Login;
